import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "20",
      height: "20",
      fill: "#fff",
      rx: "10",
      style: {"fill":"#fff","fill-opacity":"1"}
    }, null, -1),
    _createElementVNode("circle", {
      cx: "10",
      cy: "10.002",
      r: "8"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M9.19 13.58a.889.889 0 0 0 .44-.11c.136-.079.253-.189.351-.33l3.406-5.2c.058-.093.105-.189.139-.286a.768.768 0 0 0 .059-.286.701.701 0 0 0-.257-.556.848.848 0 0 0-.579-.22c-.288 0-.53.156-.725.469l-2.849 4.533-1.281-1.567a.945.945 0 0 0-.308-.264.763.763 0 0 0-.359-.08c-.22 0-.41.08-.571.241a.766.766 0 0 0-.242.572c0 .107.02.21.059.307.039.098.1.198.183.3l1.714 2.051c.117.142.241.25.373.323.132.068.28.102.447.102Z",
      style: {"fill":"#fff","fill-opacity":"1"}
    }, null, -1)
  ]))]))
}
export default { render: render }